import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import * as actions from "../../slices/profile/updateProfile.slice";
import { http } from "utils/http";
import { endPoint } from "constants/server/api";
export var updateProfile = function(payload) {
    var signal = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).signal;
    return function() {
        var _ref = _async_to_generator(function(dispatch) {
            var accessToken, result, body, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dispatch(actions.fetchData());
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        accessToken = localStorage.getItem("accessToken");
                        return [
                            4,
                            http({
                                method: "post",
                                url: endPoint.UPDATE_SETUSER,
                                headers: {
                                    Authorization: "Bearer ".concat(accessToken)
                                },
                                data: payload,
                                signal: signal
                            })
                        ];
                    case 2:
                        result = _state.sent();
                        body = result.data;
                        if ((body === null || body === void 0 ? void 0 : body.success) === false || (body === null || body === void 0 ? void 0 : body.statusCode) != null && (Number(body.statusCode) < 200 || Number(body.statusCode) >= 300)) {
                            throw new Error((body === null || body === void 0 ? void 0 : body.message) || "ไม่สามารถดำเนินการได้");
                        }
                        if (!(signal === null || signal === void 0 ? void 0 : signal.aborted)) {
                            dispatch(actions.fetchDataSuccess(body));
                        }
                        return [
                            2,
                            body
                        ];
                    case 3:
                        error = _state.sent();
                        if (!(signal === null || signal === void 0 ? void 0 : signal.aborted)) dispatch(actions.fetchDataFailure());
                        // Let the calling page display its existing error modal.
                        throw error;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
export var clearUpdateProfile = function() {
    return function(dispatch) {
        return dispatch(actions.resetState());
    };
};
